module.exports = __webpack_public_path__ + "img/prioritas_bosspack_dfod_dg.69c050db.png";